const isImage = (file) => file.type?.startsWith('image/') || /\.(heic|heif|jpe?g|png|webp)$/i.test(file.name || '');

/**
 * Ask the server to trim the table away from a receipt photo.
 * Returns the File to use: the trimmed JPEG (linked back to the original) or the
 * original itself (tagged with why it was kept). Never throws.
 */
export async function autoCropReceipt(api, file) {
  if (!isImage(file)) return file;
  try {
    const fd = new FormData();
    fd.append('file', file);
    const res = await api.post('/captures/crop', fd, { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 30000 });
    const d = res.data || {};
    if (!d.cropped || !d.image_b64) { file.cropReason = d.reason || 'no_document'; return file; }
    const bytes = Uint8Array.from(atob(d.image_b64), c => c.charCodeAt(0));
    const base = (file.name || 'receipt.jpg').replace(/\.[^.]+$/, '');
    const trimmed = new File([bytes], `${base}-trimmed.jpg`, { type: 'image/jpeg' });
    trimmed.cropOriginal = file;
    trimmed.cropInfo = { confidence: d.confidence, method: d.method };
    file.cropAlternative = trimmed;
    return trimmed;
  } catch {
    file.cropReason = 'failed';
    return file;
  }
}

export const isTrimmed = (file) => !!file?.cropOriginal;
export const cropAlternativeOf = (file) => file?.cropOriginal || file?.cropAlternative || null;
